export default {
	get: {
		
	},
	post: {
		getList: '/dmall-manage/dmallmanage/bill/list',
		detail: '/dmall-manage/dmallmanage/bill/details',
		export: '/dmall-manage/dmallmanage/bill/export/create',
		detailExport: '/dmall-manage/dmallmanage/bill/detail/export/create',
		getStore: '/dmall-manage/dmallmanage/public/getStoreInfoByGroupIdAndStoreName',
		getBizCitys: "/company-store/api/corpapi/dmall/public/getBizCityFetchAll"
  }
}